import { z } from 'zod';

export const roomSchema = z.object({
  idRoom: z.number().default(-1),
  Location_idLocation: z.number().default(0),
  Name: z.string().default(''),
  Capacity: z
    .union([z.number(), z.string(), z.null()])
    .transform(value => (value === null || value === '' ? null : Number(value)))
    .nullable()
    .default(null),
  // Vom Backend mitgeliefert (Relation): Name des zugehoerigen Standorts.
  Location: z.string().optional().default(''),
});

export type IRoom = z.infer<typeof roomSchema>;

/** Eine Terminbuchung eines Raums (Belegungsplan). */
export interface IRoomBooking {
  idLegalTransactionMeeting: number;
  idLegalTransaction: number | null;
  Title: string;
  Meeting_at: string;
  DurationInMin: number | null;
}

/** Belegung eines Raums im abgefragten Zeitfenster. */
export interface IRoomOccupancy {
  idRoom: number;
  Name: string;
  Capacity: number | null;
  bookings: IRoomBooking[];
}
